import React, { useEffect, useRef, useState } from 'react'
import OffcialLogoSvg from '../assets/svg/OffcialLogoSvg'
import { NavbarHamburgerMenuButton, NavbarPrimaryButton, PrimaryButton } from '../components/StyledButton'
import SearchIcon20pxSvg from '../assets/images/icons/svg/SearchIcon20pxSvg'
import ChevronDown16pxSvg from '../assets/images/icons/svg/ChevronDown16pxSvg'
import SmartUtilities24pxSvg from '../assets/images/icons/svg/SmartUtilities24pxSvg'
import AssetManagement24pxSvg from '../assets/images/icons/svg/AssetManagement24pxSvg'
import FacilitiesManagement24pxSvg from '../assets/images/icons/svg/FacilitiesManagement24pxSvg'
import Security24pxSvg from '../assets/images/icons/svg/Security24pxSvg'
import { StyledLink, StyledLinkGreyHoverBlue } from '../components/StyledLink'
import MenuIcon from '@mui/icons-material/Menu';
import { CustomNavbarDrawer, SubLinkList } from '../components/StyledComponents'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { MenuItem } from '@mui/material'
import { Link } from '@mui/material';
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from "react-router-dom"

const Navbar = () => {
  const { t } = useTranslation()

  const location = useLocation();

  const useCaseLink = [
    {
      name: t('public.smart-utilities'),
      image: <SmartUtilities24pxSvg className="absolute left-0 top-[-2px]" />,
      subLinks: [
        {
          name: t('public.smart-gas-metering'),
          path: ""
        },
        {
          name: t('public.smart-water-metering'),
          path: ""
        },
        {
          name: t('public.smart-power-metering'),
          path: ""
        },
      ]
    },
    {
      name: t('public.asset-management'),
      image: <AssetManagement24pxSvg className="absolute left-0" />,
      subLinks: [
        {
          name: t('public.global-iot-tracking'),
          path: ""
        },
        {
          name: t('public.indoor-tracking'),
          path: ""
        },
        {
          name: t('public.outdoor-tracking'),
          path: ""
        },
        {
          name: t('public.aed-monitoring'),
          path: ""
        },
        {
          name: t('public.cold-chain-monitoring'),
          path: ""
        },
        {
          name: t('public.aerospace-ground-service-equipment-monitoring'),
          path: ""
        },
      ]
    },
    {
      name: t('public.facilities-management'),
      image: <FacilitiesManagement24pxSvg className="absolute left-0" />,
      subLinks: [
        {
          name: t('public.smart-toilet-management'),
          path: ""
        },
        {
          name: t('public.smart-waste-management'),
          path: ""
        },
        {
          name: t('public.electrical-water-metering-and-iaq-monitoring'),
          path: ""
        },
        {
          name: t('public.temperature-humidity-and-indoor-air-quality'),
          path: ""
        },
        {
          name: t('public.rodent-monitoring'),
          path: ""
        },
        {
          name: t('public.smart-parking'),
          path: ""
        },
        {
          name: t('public.smart-airport'),
          path: ""
        },
      ]
    },
    {
      name: t('public.security'),
      image: <Security24pxSvg className="absolute left-0" />,
      subLinks: [
        {
          name: t('public.security-alarm-backup'),
          path: ""
        },
        {
          name: t('public.smart-emergency-response'),
          path: ""
        },
        {
          name: t('public.stolen-vehicle-recovery'),
          path: ""
        },
      ]
    },
  ]

  const [openSolutions, setOpenSolutions] = useState(false)
  const [openProducts, setOpenProducts] = useState(false)
  const [openIOT, setOpenIOT] = useState(false)
  const [openAboutUs, setOpenAboutUs] = useState(false)

  const anchorRefSolutions = useRef(null)
  const anchorRefProducts = useRef(null)
  const anchorRefIOT = useRef(null)
  const anchorRefAboutUs = useRef(null)

  const handleToggleSolutions = () => {
    setOpenSolutions((prevOpenUseCase) => !prevOpenUseCase);
  }

  const handleToggleProducts = () => {
    setOpenProducts((prevOpenProducts) => !prevOpenProducts);
  }

  const handleToggleIOT = () => {
    setOpenIOT((prevOpenIOT) => !prevOpenIOT);
  }

  const handleToggleAboutUs = () => {
    setOpenAboutUs((prevOpenAboutUs) => !prevOpenAboutUs);
  }

  const navLinks = [
    {
      name: t('public.solutions'),
      path: "",
      id: "solutions-menu",
      button: "solutions-button",
      ref: anchorRefSolutions,
      open: openSolutions,
      handleToggle: handleToggleSolutions,
      subLinks: [
        {
          name: t('public.custom-design-and-manufacturing'),
          path: ""
        },
        {
          name: t('public.smart-parcels-tracking-seegale-solution'),
          path: ""
        },
        {
          name: t('public.smart-glass-rack-tracking-solution'),
          path: ""
        },
        {
          name: t('public.returnable-asset-tracking-for-logistics'),
          path: ""
        },
        {
          name: t('public.indoor-air-quality-and-energy-efficiency-solution'),
          path: ""
        },
        {
          name: t('public.green-buildings-solution'),
          path: ""
        },
      ]
    },
    {
      name: t('public.products'),
      path: "",
      id: "products-menu",
      button: "products-button",
      ref: anchorRefProducts,
      open: openProducts,
      handleToggle: handleToggleProducts,
      subLinks: [
        {
          name: t('public.mrconnect-data-platform'),
          path: "/mrconnect-iot-cloud-platform"
        },
        {
          name: t('public.mrtag-asset-management'),
          path: ""
        },
        {
          name: t('public.ready-to-use-products'),
          path: ""
        },
      ]
    },
    {
      name: t('public.iot-connectivity'),
      path: "",
      id: "iot-connectivity-menu",
      button: "iot-connectivity-button",
      ref: anchorRefIOT,
      open: openIOT,
      handleToggle: handleToggleIOT,
      subLinks: [
        {
          name: t('public.sigfox'),
          path: ""
        },
        {
          name: t('public.lorawan'),
          path: ""
        },
        {
          name: t('public.global-cellular-connectivity'),
          path: ""
        },
        {
          name: t('public.satellite'),
          path: ""
        },
      ]
    },
    {
      name: t('public.about-us'),
      path: "",
      id: "about-us-menu",
      button: "about-us-button",
      ref: anchorRefAboutUs,
      open: openAboutUs,
      handleToggle: handleToggleAboutUs,
      subLinks: [
        {
          name: t('public.news'),
          path: ""
        },
        {
          name: t('public.governance'),
          path: ""
        },
        {
          name: t('public.partners'),
          path: ""
        },
        {
          name: t('public.sustainability'),
          path: ""
        },
      ]
    }
  ]

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [openHamburgerMenu, setOpenHamburgerMenu] = useState(false)

  const handleOpenHamburgerMenu = () => {
    setOpenHamburgerMenu(true)
  }

  const handleCloseHamburgerMenu = () => {
    setOpenHamburgerMenu(false)
  }

  const isUseCaseActive = useCaseLink.some(link =>
    link.subLinks.some(sublink => sublink.path === location.pathname)
  );

  return (
    <div className='bg-primary shadow-navbar sticky top-0 z-50 mx-auto max-w-[1920px]'>
      {windowWidth > 1250 ?
        <div className='flex justify-between'>
          <div className='flex items-center gap-2'>
            <StyledLink className='px-8 py-7 cursor-pointer' href="/">
              <OffcialLogoSvg />
            </StyledLink>
            <ul className='flex text-white gap-4'>
              <li className={`group font-semibold py-7 px-1 nav_links ${isUseCaseActive ? "active" : ""}`}>
                <div className='flex items-center gap-[2px] nav_links_title'>
                  <p className='uppercase text-sm 2xl:text-base font-semibold'>{t('public.use-case')}</p>
                  <ChevronDown16pxSvg className="transition-transform group-hover:reverse-icon duration-300" />
                </div>
                <div className="absolute hidden group-hover:block left-[3%] top-[75px] 2xl:top-[79px] bg-[#19293B] border-t border-[#ffffff4d] font-normal text-grey-primary max-w-[1100px] 2xl:max-w-[1400px] w-full
              ">
                  <ul className='flex gap-10 p-6'>
                    {useCaseLink.map((link, index) => {
                      return (
                        <li className='w-1/4' key={index}>
                          <ul className='pl-8 relative'>
                            <li className="uppercase text-white text-lg font-bold pb-10 flex">
                              {link.image}
                              {link.name}
                            </li>
                            {link.subLinks.map((subLink, subLinkIndex) => (
                              <li className='pb-5' key={subLinkIndex}>
                                <StyledLinkGreyHoverBlue className={`${subLink.path === location.pathname ? "active" : ""}`} href={subLink.path ? subLink.path : undefined}>{subLink.name}</StyledLinkGreyHoverBlue>
                              </li>
                            ))}
                          </ul>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </li>
              {navLinks.map((link, index) => {
                const isActive = link.subLinks.some(sublink => sublink.path === location.pathname);
                return (
                  <li className={`group font-semibold py-7 px-1 nav_links relative ${isActive ? "active" : ""}`} key={index}>
                    <div className='flex items-center gap-[2px] nav_links_title'>
                      <p className='uppercase text-sm 2xl:text-base font-semibold'>{link.name}</p>
                      <ChevronDown16pxSvg className="transition-transform group-hover:reverse-icon duration-300" />
                    </div>
                    <div className="absolute hidden group-hover:block top-[75px] 2xl:top-[79px] bg-[#19293B] border-t border-[#ffffff4d] w-max max-w-[300px] font-normal left-0">
                      <div className='flex gap-5'>
                        <ul className='p-6'>
                          {link.subLinks.map((sublink, index) => (
                            <li key={index} className='pb-5 last-of-type:pb-0'>
                              <StyledLinkGreyHoverBlue href={sublink.path ? sublink.path : undefined} className={location.pathname === sublink.path ? "active" : ""}>{sublink.name}</StyledLinkGreyHoverBlue>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
          <div className='flex gap-3'>
            <div className='relative self-center'>
              <input type="text" name='search' className='input-search placeholder:text-xs text-xs' placeholder={t('placeholder.search-by-keyword')} />
              <SearchIcon20pxSvg className="input-search-icon" />
            </div>
            <NavbarPrimaryButton>{t('button.contact-us')}</NavbarPrimaryButton>
          </div>
        </div>
        :

        //Hamburger menu
        <div className='flex justify-between items-center px-4'>
          <div className='flex items-center gap-2'>
            <StyledLink className='py-7 cursor-pointer' href="/">
              <OffcialLogoSvg />
            </StyledLink>
          </div>
          <NavbarHamburgerMenuButton onClick={handleOpenHamburgerMenu}>
            <MenuIcon />
          </NavbarHamburgerMenuButton>
          <CustomNavbarDrawer
            anchor="right"
            open={openHamburgerMenu}
            onClose={handleCloseHamburgerMenu}
          >
            <div className='hamburger-menu'>
              <div className='flex justify-between items-center'>
                <StyledLink className='cursor-pointer'>
                  <OffcialLogoSvg />
                </StyledLink>
                <IconButton onClick={handleCloseHamburgerMenu}>
                  <CloseIcon className='text-white' fontSize='large' />
                </IconButton>
              </div>
              <div className='flex'>
                <ul className='text-white w-full'>
                  <li className='pb-5 border-b border-[#ffffff99]'>
                    <div>
                      <StyledLinkGreyHoverBlue className='!font-semibold'>
                        {t('public.home')}
                      </StyledLinkGreyHoverBlue>
                    </div>
                  </li>
                  <li className='pb-5 border-b border-[#ffffff99]'>
                    <div>
                      <StyledLinkGreyHoverBlue className='!font-semibold'>{t('public.use-case')}</StyledLinkGreyHoverBlue>
                    </div>
                  </li>
                  {navLinks.map((value, index) => {
                    return (
                      <li className='relative pb-5 border-b border-[#ffffff99]' key={index}>
                        <div className=''>
                          <StyledLinkGreyHoverBlue
                            component="button"
                            ref={value.ref}
                            id={value.button}
                            aria-controls={value.open ? value.id : undefined}
                            aria-expanded={value.open ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={value.handleToggle}
                            className='w-full !font-semibold'
                          >
                            <div className='flex items-center justify-between pr-3'>
                              <Link href={value.path ? value.path : undefined}>{value.name}</Link>
                              <ChevronDown16pxSvg className={`${value.open ? "reverse-icon" : ""}`} />
                            </div>
                          </StyledLinkGreyHoverBlue>
                          {value.open ?
                            <SubLinkList
                              id={value.id}
                              aria-labelledby={value.button}
                            >
                              {value.subLinks.map((subLink, subLinkIndex) => (
                                <MenuItem key={subLinkIndex}>
                                  <Link href={subLink.path ? subLink.path : undefined} className={`${location.pathname === subLink.path ? "active" : ""} !font-semibold`}>{subLink.name}</Link>
                                </MenuItem>
                              ))}
                            </SubLinkList>
                            : null}
                        </div>
                      </li>
                    )
                  })}
                  {/* <li className='relative'>
                  <div>
                    <StyledLinkGreyHoverBlue
                      component="button" ref={anchorRefSolutions}
                      id="solutions-button"
                      aria-controls={openSolutions ? 'solutions-menu' : undefined}
                      aria-expanded={openSolutions ? 'true' : undefined}
                      aria-haspopup="true"
                      onClick={handleToggleSolutions}
                    >
                      <div className='flex items-center justify-center gap-2'>
                        <p>{t('public.solutions')}</p>
                        <ChevronDown16pxSvg className={`duration-300 ${openSolutions ? "reverse-icon" : ""}`} />
                      </div>
                    </StyledLinkGreyHoverBlue>
                    {openSolutions ?
                      <CenterMenuList
                        id="solutions-menu"
                        aria-labelledby="solutions-button"
                      >
                        <MenuItem>
                          <Link>{t('public.custom-design-and-manufacturing')}</Link>
                        </MenuItem>
                        <MenuItem>
                          <Link>{t('public.smart-parcels-tracking-seegale-solution')}</Link>
                        </MenuItem>
                        <MenuItem>
                          <Link>{t('public.smart-glass-rack-tracking-solution')}</Link>
                        </MenuItem>
                        <MenuItem>
                          <Link>{t('public.smart-roller-cages-tracking-solution')}</Link>
                        </MenuItem>
                        <MenuItem>
                          <Link>{t('public.indoor-air-quality-and-energy-efficiency-solution')}</Link>
                        </MenuItem>
                        <MenuItem>
                          <Link>{t('public.green-buildings-solution')}</Link>
                        </MenuItem>
                      </CenterMenuList>
                      : null}
                  </div>
                </li>
                <li>
                  <div>
                    <StyledLinkGreyHoverBlue
                      component="button" ref={anchorRefProducts}
                      id="products-button"
                      aria-controls={openProducts ? 'products-menu' : undefined}
                      aria-expanded={openProducts ? 'true' : undefined}
                      aria-haspopup="true"
                      onClick={handleToggleProducts}
                    >
                      <div className='flex items-center justify-center gap-2'>
                        <p>{t('public.products')}</p>
                        <ChevronDown16pxSvg className={`duration-300 ${openProducts ? "reverse-icon" : ""}`} />
                      </div>
                    </StyledLinkGreyHoverBlue>
                    {openProducts ?
                      <CenterMenuList
                        id="product-menu"
                        aria-labelledby="product-button"
                      >
                        <MenuItem>
                          <Link className="active">{t('public.mrconnect-data-platform')}</Link>
                        </MenuItem>
                        <MenuItem>
                          <Link>{t('public.mrtag-asset-management')}</Link>
                        </MenuItem>
                        <MenuItem>
                          <Link>{t('public.ready-to-use-products')}</Link>
                        </MenuItem>
                      </CenterMenuList>
                      : null}
                  </div>
                </li>
                <li>
                  <div>
                    <StyledLinkGreyHoverBlue>{t('public.iot-connectivity')}</StyledLinkGreyHoverBlue>
                  </div>
                </li>
                <li>
                  <div>
                    <StyledLinkGreyHoverBlue
                    >
                      <div className='flex items-center justify-center gap-2'>
                        <p>{t('public.about-us')}</p>
                        <div component="button" ref={anchorRefAboutUs}
                          id="about-us-button"
                          aria-controls={openAboutUs ? 'about-us-menu' : undefined}
                          aria-expanded={openAboutUs ? 'true' : undefined}
                          aria-haspopup="true"
                          onClick={handleToggleAboutUs}>
                          <ChevronDown16pxSvg className={`duration-300 ${openAboutUs ? "reverse-icon" : ""}`}
                          />
                        </div>
                      </div>
                    </StyledLinkGreyHoverBlue>
                    {openAboutUs ?
                      <CenterMenuList
                        id="about-us-menu"
                        aria-labelledby="about-us-button"
                      >
                        <MenuItem>
                          <Link>{t('public.news')}</Link>
                        </MenuItem>
                        <MenuItem>
                          <Link>{t('public.governance')}</Link>
                        </MenuItem>
                        <MenuItem>
                          <Link>{t('public.partners')}</Link>
                        </MenuItem>
                        <MenuItem>
                          <Link>{t('public.sustainability')}</Link>
                        </MenuItem>
                      </CenterMenuList>
                      : null}
                  </div>
                </li> */}
                  <li className='flex justify-start'>
                  <PrimaryButton className='!mt-2'>{t('button.contact-us')}</PrimaryButton>
                  </li>
                </ul>

              </div>
            </div>
          </CustomNavbarDrawer>
        </div >
      }
    </div >
  )
}

export default Navbar